<template>
  <div class="loan">
    <div style="position: fixed; top: 50%; left: 50%; z-index: 999;"></div>

    <div class="mb-3" v-if="processingError">
      <va-notification color="danger" closeable>
        An error occurred! Please Try again later.
      </va-notification>
    </div>

    <div class="row">
      <div class="flex s12 md9">
        <va-card>
          <va-input
            class="ma-0"
            :value="term"
            placeholder="Search by date"
            @input="search"
            removable
          >
            <va-icon name="fa fa-search" slot="prepend" />
          </va-input>

          <va-data-table
            :fields="mode ? detailedFields : fields"
            :data="filteredData"
            :loading="loading"
            hoverable
          >
            <template slot="icon">
              <va-icon name="fa fa-list" color="secondary" />
            </template>

            <template v-slot:date_sent="props">
              {{ props.rowData.date_sent }} at {{ props.rowData.time_sent }}
            </template>

            <template v-slot:message="props">
              {{ props.rowData.message }}
            </template>
          </va-data-table>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import * as spinners from 'epic-spinners'
import debounce from 'lodash/debounce'

export default {
  components: { ...spinners },
  name: 'loan',
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('LoggedUser')),
      accdetails: JSON.parse(localStorage.getItem('UserMianFosa')),
      token: JSON.parse(localStorage.getItem('Token')),
      loan_no: this.$route.params.loan_no,
      loading: false,
      term: null,
      loadSelect: false,
      details: [],
      config: {
        size: 80,
        duration: 1500,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      sliderDuration: {
        min: 1000,
        max: 2000,
      },
    }
  },
  computed: {
    speed() {
      return this.sliderDuration.min + this.sliderDuration.max - this.currentDuration
    },
    fields() {
      return [
        {
          name: '__slot:icon',
          width: '20px',
          dataClass: 'text-center',
        },
        {
          name: '__slot:date_sent',
          title: this.$t('Date sent'),
          width: '30%',
          sortField: 'amount',
        },
        {
          name: '__slot:message',
          title: this.$t('Messages'),
          width: '70%',
          sortField: 'amount',
        },
      ]
    },
    filteredData() {
      if (!this.term || this.term.length < 1) {
        return this.details
      }
      return this.details.filter((item) => {
        return (
          item.message.toLowerCase().startsWith(this.term.toLowerCase()) ||
          item.date_sent.toLowerCase().startsWith(this.term.toLowerCase())
        )
      })
    },
  },
  methods: {
    GetNotifications() {
      const self = this
      const config = {
        headers: {
          Authorization: `${this.userData.user_id} ${this.token}`,
        },
      }

      axios
        .post(`${self.$apiUrl}GetNotifications`, self.userData.user_id, config)
        .then(function (res) {
          self.loadSelect = false
          self.loading = false
          self.details = res.data.slice()
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    search: debounce(function (term) {
      this.term = term
    }, 400),
  },
  created() {
    this.GetNotifications()
  },
}
</script>
